import { motion } from "framer-motion";
import { ShieldAlert } from "lucide-react";
import { Button } from "./ui/button";

const AgeGate = ({ onVerify, onDeny }) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/95 backdrop-blur-3xl">
      {/* Background effects */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-primary/10 rounded-full blur-3xl" />
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-secondary/10 rounded-full blur-3xl" />
      </div>

      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
        className="relative z-10 max-w-md w-full mx-4"
      >
        <div className="glass rounded-2xl p-8 neon-border text-center">
          {/* Logo */}
          <motion.div
            initial={{ y: -20 }}
            animate={{ y: 0 }}
            transition={{ delay: 0.2 }}
            className="mb-6"
          >
            <h1 className="font-unbounded text-3xl font-bold gradient-text">
              AIRO VAPOR
            </h1>
          </motion.div>

          {/* Shield Icon */}
          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ delay: 0.3, type: "spring" }}
            className="flex justify-center mb-6"
          >
            <div className="w-20 h-20 rounded-full bg-primary/20 flex items-center justify-center animate-pulse-neon">
              <ShieldAlert className="w-10 h-10 text-primary" />
            </div>
          </motion.div>

          {/* Warning Text */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.4 }}
          >
            <h2 className="font-unbounded text-xl font-semibold mb-3 text-foreground">
              Age Verification Required
            </h2>
            <p className="text-muted-foreground mb-6 font-outfit">
              This website contains products intended for adults 21 years of age
              or older. By entering, you confirm that you are of legal age.
            </p>
          </motion.div>

          {/* Buttons */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.5 }}
            className="flex flex-col gap-3"
          >
            <Button
              data-testid="age-verify-yes-btn"
              onClick={onVerify}
              className="w-full bg-primary text-primary-foreground hover:bg-primary/90 font-outfit font-semibold py-6 text-lg rounded-xl neon-box"
            >
              Yes, I am 21 or older
            </Button>
            <Button
              data-testid="age-verify-no-btn"
              onClick={onDeny}
              variant="outline"
              className="w-full border-border text-muted-foreground hover:bg-muted font-outfit py-6 text-lg rounded-xl"
            >
              No, I am under 21
            </Button>
          </motion.div>

          {/* Disclaimer */}
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.6 }}
            className="mt-6 text-xs text-muted-foreground font-outfit"
          >
            WARNING: This product contains nicotine. Nicotine is an addictive chemical.
          </motion.p>
        </div>
      </motion.div>
    </div>
  );
};

export default AgeGate;
